import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { LetDirective } from '@ngrx/component';

import { OrderSearchStore } from '../order-search.store';
import { OrdersTableComponent } from '../orders-table/orders-table.component';

@Component({
  selector: 'orders-table-container',
  imports: [LetDirective, OrdersTableComponent],
  templateUrl: './table-container.component.html',
  styleUrls: ['./table-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableContainerComponent {
  protected tableModel$ = inject(OrderSearchStore).tableModel$;
}
